import React from 'react'
import style from './TextInput.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const PasswordInput = ({ name, value, title, onChange, placeholder, id, className, show, setShow }) => {
  return (
    <div className={`${className || ''} ${style.cover}`}>
      <label htmlFor={id}>{title}</label>
      <div className={style.password}>
      <input 
        name={name}
        value={value}
        id={id}
        placeholder={placeholder}
        onChange={onChange ? (event) => onChange(event) : undefined}
        className={style.textInput}
        type={show ? "text" : "password"}
      />
      <FontAwesomeIcon icon={show ? faEyeSlash : faEye} onClick={() => setShow(!show)}/>
      </div>
    </div>
  );
}

export default PasswordInput;
